function nodeSiblings(r){var e=[];return Array.prototype.filter.call(r.parentNode.children,function(n){n!==r&&e.push(n)}),e}